(function () {
  function initManagementTeam() {
    const managementEl = document.querySelector('.management[data-section-id]');
    if (!managementEl) return;

    const fixedCode = managementEl.querySelector('.fixed-code');
    const closeBtn = managementEl.querySelector('.manage-close-box');
    const swiperContainer = managementEl.querySelector('.management-swiper');
    const sectionId = managementEl.dataset.sectionId;

    if (!fixedCode || !closeBtn || !swiperContainer) return;

    let swiperInstance = null;

    function showDetailInfo(show) {
      if (show) {
        document.body.style.overflowY = 'hidden';
        fixedCode.style.display = 'flex';
        fixedCode.setAttribute('data-visible', 'true');
      } else {
        document.body.style.overflowY = '';
        fixedCode.style.display = 'none';
        fixedCode.removeAttribute('data-visible');
      }
    }

    function initSwiper(initialIndex) {
      if (swiperInstance && swiperInstance.slider) {
        swiperInstance.slider.destroy();
        swiperInstance = null;
      }

      if (typeof window.FoxTheme === 'undefined' || !window.FoxTheme.Swiper) return;

      const Swiper = window.FoxTheme.Swiper;
      const additionModules = [];
      if (Swiper && Swiper.Scrollbar) {
        additionModules.push(Swiper.Scrollbar);
      }

      const isMobileViewport = window.matchMedia('(max-width: 767.98px)').matches;
      const options = {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: isMobileViewport ? 300 : 1000,
        initialSlide: initialIndex,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: managementEl.querySelector('.swiper-button-next'),
          prevEl: managementEl.querySelector('.swiper-button-prev'),
        },
        pagination: false,
      };

      swiperInstance = new window.FoxTheme.Carousel(swiperContainer, options, additionModules);
      swiperInstance.init();

      if (swiperInstance.slider) {
        const swiper = swiperInstance.slider;
        const barEl = managementEl.querySelector('.swiper-scrollbar');
        const dragEl = managementEl.querySelector('.swiper-scrollbar-drag');

        function updateScrollbar() {
          if (!barEl || !dragEl || swiper.slides.length <= 1) return;

          const total = swiper.slides.length;
          const barW = barEl.offsetWidth;
          const dragW = barW / total;
          dragEl.style.width = dragW + 'px';

          const maxWrapperTranslate = -swiper.size * (total - 1);
          const maxDragTranslate = barW - dragW;

          const progress = Math.max(0, Math.min(1, swiper.translate / maxWrapperTranslate));
          const dragTranslate = maxDragTranslate * progress;

          dragEl.style.transform = `translate3d(${dragTranslate}px, 0, 0)`;
        }

        swiper.on('slideChangeTransitionStart', function () {
          if (dragEl) {
            dragEl.style.transitionDuration = swiper.params.speed + 'ms';
            dragEl.style.transitionProperty = 'transform';
          }
          updateScrollbar();
        });

        swiper.on('slideChangeTransitionEnd', function () {
          if (dragEl) {
            dragEl.style.transitionDuration = '0ms';
            dragEl.style.transitionProperty = 'none';
          }
          updateScrollbar();
        });

        swiper.on('setTranslate', function () {
          // 仅处理拖拽场景（非动画切换时同步位置）
          if (!swiper.animating) {
            updateScrollbar();
          }
        });

        swiper.on('resize', function () {
          updateScrollbar();
        });

        setTimeout(() => {
          if (dragEl) dragEl.style.transitionDuration = '0ms';
          updateScrollbar();
        }, 50);
      }
    }

    function handleItemClick(index) {
      showDetailInfo(true);
      setTimeout(() => {
        initSwiper(index);
      }, 50);
    }

    closeBtn.addEventListener('click', function () {
      showDetailInfo(false);
      if (swiperInstance) {
        swiperInstance.slider.destroy();
        swiperInstance = null;
      }
    });

    const clickableItems = managementEl.querySelectorAll('.manage-content-first, .manage-content');
    clickableItems.forEach(function (item) {
      const index = parseInt(item.getAttribute('data-index'), 10);
      if (!isNaN(index)) {
        item.addEventListener('click', function () {
          handleItemClick(index);
        });
      }
    });

    fixedCode.addEventListener('click', function (e) {
      if (e.target === fixedCode) {
        showDetailInfo(false);
        if (swiperInstance) {
          swiperInstance.slider.destroy();
          swiperInstance = null;
        }
      }
    });

    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        if (e.detail.sectionId === sectionId) {
          initManagementTeam();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initManagementTeam);
  } else {
    initManagementTeam();
  }
})();